import React from "react";

import { MetricGridProps } from "./types";
import { Metric, Metrics } from "./styles";

export const MetricGrid: React.FC<MetricGridProps> = ({ metrics }) => (
  <Metrics>
    {metrics.map(({ label, labelHint, value, title, spansRow }) => (
      <Metric key={label} title={title} $spansRow={spansRow}>
        <dt>
          {label}
          {labelHint}
        </dt>
        <dd>{value}</dd>
      </Metric>
    ))}
  </Metrics>
);
